var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5382 9.09624C13.5382 12.4787 8.46131 12.4787 8.46131 9.09624H9.73054C9.73054 10.7907 12.269 10.7907 12.269 9.09624M16.0767 14.8078V16.7116H5.92285V14.8078C5.92285 13.1134 9.30535 12.2693 10.9998 12.2693C12.6942 12.2693 16.0767 13.1134 16.0767 14.8078ZM14.8709 14.8078C14.8709 14.4016 12.8846 13.4751 10.9998 13.4751C9.11497 13.4751 7.12862 14.4016 7.12862 14.8078V15.5059H14.8709M11.3171 4.65393C11.4948 4.65393 11.6344 4.79355 11.6344 4.97124V6.87508H12.269V5.28855C12.7181 5.4964 13.0944 5.83444 13.349 6.2588C13.6036 6.68316 13.7248 7.17426 13.6969 7.66835C13.6969 7.66835 14.1411 7.7572 14.1729 8.46162H7.8267C7.8267 7.7572 8.30266 7.66835 8.30266 7.66835C8.27471 7.17426 8.3959 6.68316 8.65052 6.2588C8.90514 5.83444 9.28142 5.4964 9.73054 5.28855V6.87508H10.3652V4.97124C10.3652 4.79355 10.5048 4.65393 10.6825 4.65393",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.25f22096846008abbbcf0e10df5425a3.svg";
export { ForwardRef as ReactComponent };